var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOvalSeccao15(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1334.33 888.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1 {\r\n        opacity: 0.5;\r\n        isolation: isolate;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "oval-seccao-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "oval-transparencia-rotacao",
    className: "cls-1 rotate-center-right",
    d: "M1121.55,10.7a240.24,240.24,0,0,0-41.22-3.54l.16-.06s-232.33-8.78-448,153.76l.15-.05C571.41,203,525.64,271.75,511.4,354.65s5.9,163,49.4,223.34C709.35,803.21,930.29,873.55,931.59,874a240.58,240.58,0,0,0,39.87,10.52c112.41,19.52,221.49-43,275-147,0,0,91.17-163.9,87.83-453.18h0C1335,149.84,1247.38,32.56,1121.55,10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "oval-branca",
    className: "cls-2",
    d: "M255.18,723.61a241.16,241.16,0,0,0,37.25-3.47l-.13.07s208.16-28.52,373.57-191.87l-.12.06c47.56-43.19,77-105.32,76.19-174s-31.85-129.78-80.41-171.52C492.59,25.06,284.52,2.49,283.3,2.36A239.84,239.84,0,0,0,246.1,0C142.89,1.58,56,68.4,25.45,160c0,0-54.37,145.37-4.18,376.81h0C42.53,644.72,139.64,725.35,255.18,723.61Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvalSeccao15);
export default __webpack_public_path__ + "static/media/oval-seccao15.a3f4b090d8f0a3392fb9217c5af03c00.svg";
export { ForwardRef as ReactComponent };